import { render } from "./ztn-radio.vue?vue&type=template&id=1904e24d&scoped=true&ts=true"
import script from "./ztn-radio.vue?vue&type=script&lang=ts"
export * from "./ztn-radio.vue?vue&type=script&lang=ts"

import "./ztn-radio.vue?vue&type=style&index=0&id=1904e24d&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.5.16_vue@3.5.16_typescript@4.8.4__webpack@5.84.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1904e24d"]])

export default __exports__